export enum PatientTypes {
    none = 0,
    inPatient = 1,
    outPatient = 2,
    Both = 3
}
